import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import { UtilsPcvizService } from '@mirage-projects/cw-pcviz-core';

/**
 * Point selector service
 * Set the point for the workflow import wizard step
 */
@Injectable()
export class PointSelectorService {
    pointFromPivot: Float64Array;
    newStationCenter: Float64Array;
    pointSelectorForm: FormGroup = this.formBuilder.group({
        editCenter: [false],
        x: [0],
        y: [0],
        z: [0],
    });

    constructor(
        private formBuilder: FormBuilder,
        private utilsPcvizService: UtilsPcvizService
    ) {
        const mathUtils = this.utilsPcvizService.getMathUtils();
        this.pointFromPivot = this.utilsPcvizService.getMathUtils().vec3.create();

        // TODO: set pointfrom value to the one of the project
        // if ( this.Project.getView3D().getViewer().getManipulator()._pivotPoint ) {
        //     MathUtils.vec3.copy( this._pointFromPivot, this.Project.getView3D().getViewer().getManipulator()._pivotPoint );
        // }

        this.newStationCenter = mathUtils.vec3.create();
        this.setPoints(this.newStationCenter);
    }

    /**
     * Set the point coordinates
     */
    setPoints(point: Float64Array): void {
        this.pointSelectorForm.get('x')?.setValue(point[0]);
        this.pointSelectorForm.get('y')?.setValue(point[1]);
        this.pointSelectorForm.get('z')?.setValue(point[2]);
    }
}
